import styled from "styled-components";

export const PrioritySelect = styled.select`
    width: 7rem;
    height: 2.5rem;
    border-radius: 20px;
    border: none;
    background-color: #EBEBEB;
    font-size: 14px;
    padding: 0.5rem;
`

export const Select = styled.select`
    width: 12.5rem;
    height: 2.5rem;
    border-radius: 20px;
    border: none;
    background-color: #EBEBEB;
    font-size: 14px;
    padding: 0.5rem;
`